import styled from 'astroturf/react';
import s from 'src/components/DataGrid/Base';

const Column = styled(s.Column)`
  flex: 1;

  &:first-child {
    flex: 0 0 200px;
  }
`;

const Item = styled(s.Item)`
  flex: 1;

  &:first-child {
    flex: 0 0 200px;
  }

  &.capitalize {
    text-transform: capitalize;
  }
`;

export default {
  ...s,
  Column,
  Item,
};
